import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { GenericPopUp } from "../../components/popup/genericPopUp";
import { DownloadSingleReportConfig, grnRowsData, popupType } from "../../types/types";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { InputLabel, MenuItem, FormControl, Select } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CustomDataGrid from "../../components/dms_common/CustomDataGrid";
import dayjs, { Dayjs } from "dayjs";
import { Alert, Button, Snackbar, Stack, TextField } from "@mui/material";
import { ViewAllGrnConfig, ViewAllGrnConfigV2 } from "./ViewAllGrnConfig";
import { getGrnList, getUTCDate } from "../../services/manageOrderService";
import "./ViewAllGrn.css";
import "../viewOrder/ViewOrder.css";
import { ReactComponent as DownloadAllIcon } from "../../assets/image/svg/downloadAllWhite.svg";
import "../manageBasket/ManageBasket.css";
import { Loader } from "../../components/loader/Loader";
import {
  filterData,
  searchWithStatusFilter,
  updateDatesInLocalStorage,
} from "../../components/dms_common/DmsCommonServices";
import { isGapMoreThanNDays, isStartDateIsGreaterThanEndDate } from "../../utils/calenderUtils";
import { downloadAllReports } from "../../services/manageReportService";
import Header from "../../components/dms_common/Header";
import useSessionStorageDates from "../../components/dms_common/UseSessionStorageDates";
import { getConfigData } from "../../services/configurationService";
import { analytics, logLoadTrace } from "../../../src/firebase";
import { logEvent } from "firebase/analytics";
import { fetchSessionStorageFilter, safeStringify, updateSessionStorageFilter } from "../../components/dms_common/DmsUtils";
import { FilterKeys } from "../../types/types";
import { getDownloadSingleReportConfig } from "../secondaryOrder/ManageSecondaryOrderUtils";
import { sendSlackAlert, SlackChannel } from "../../services/slackService";
import HeaderV2 from "../../components/dms_common/HeaderV2";
import { defaultRangesConfig, RangeConfig } from "../../components/dms_common/QuickDateRangePicker";
import MultiCategoryFilterV2 from "../../components/dms_common/MultiCategoryFilterV2";
import { generatePrimarySummary, initialSummaryValuesGRN } from "../primaryOms/ManagePrimaryOrderUtils";
import GenericSummaryCard, { GenericSummaryCardItemObject } from "../../components/dms_common/GenericSummaryCard";
import TextSwitcher, { TextSwitcherItemObject } from "../../components/dms_common/TextSwitcher";

const ViewAllGrn = () => {
  const ConfigDictionary = JSON.parse(
    localStorage.getItem("ConfigDictionary") ?? "{}"
  );
  const startDateAtLastNDays = ConfigDictionary?.startDateAtLastNDays ?? 0
  const newStartDate = dayjs().subtract(startDateAtLastNDays, 'day')
  const { storedStartDate, storedEndDate, storeSessionStorageDates } = useSessionStorageDates("viewAllGrns", newStartDate)
  const filterValue = fetchSessionStorageFilter(FilterKeys.PRIMARY_ViewAllGrn ) ?? "OPEN";
  updateSessionStorageFilter(FilterKeys.PRIMARY_ViewPrimaryOrders, "ALLORDERS")
  const feature = "Purchase";
  const pageID = "ViewAllGRN";

  const [openGenericModal, setOpenGenericModal] = useState<boolean>(false);
  const [popupType, setPopupType] = useState<popupType>("Alert");
  const [genericMessage, setGenericMessage] = useState<string>("");
  const [data, setData] = useState<grnRowsData[]>([]);
  const [rows, setRows] = useState<grnRowsData[]>([]);
  const [grnStages, setGrnStages] = useState<any[]>([]);
  const [loader, setLoader] = useState(false);
  const [startDate, setStartDate] = useState<Dayjs>(storedStartDate);
  const [endDate, setEndDate] = useState<Dayjs>(storedEndDate);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [searchedValue, setSearchedValue] = useState<string>("");
  const [statusFilter, setStatusFilter] = useState<string>(filterValue);
  const [resetSearch, setResetSearch] = useState(false);
  const primaryOrderTrackingStagesRef = useRef<any[]>([]);
  const allGrnsReportIdRef = useRef<string | null>(null);
  const singleGrnReportIdRef = useRef<string | null>(null);
  const [downloadSingleReportConfig, setDownloadSingleReportConfig] =
      useState<DownloadSingleReportConfig | null>();
  const [isButtonLoading, setIsButtonLoading] = useState(false);

  const rangesConfig: RangeConfig[] = ConfigDictionary.quickDateRanges ?? defaultRangesConfig;
  const ranges = React.useMemo(
    () =>
      rangesConfig.map(({ label, days }) => ({
        label,
        days,
        getRange: (): [Dayjs, Dayjs] => {
          if (days === 0) return [dayjs().startOf("day"), dayjs().endOf("day")];
          return [dayjs().subtract(days, "day").startOf("day"), dayjs().endOf("day")];
        },
      })),
    []
  );

  const daysCount = startDate && endDate ? endDate.diff(startDate, 'day') : 0;
  const label = (ranges.find(r => r.days === daysCount)?.label || "selected Date Range");


  const [lastRefreshed, setLastRefreshed] = useState<Dayjs>(dayjs());
  const [dateRangeLabel, setDateRangeLabel] = useState<string>(label);

  const [filterOpen, setFilterOpen] = useState<boolean>(false);
  const [selectedFilterType, setSelectedFilterType] = useState<string>("status");
  const [filterSearchValue, setFilterSearchValue] = useState<string>("");


  const storedFilters = JSON.parse(localStorage.getItem("viewAllGRNFilter") ?? "{}");
  const [selectedStatusTypes, setSelectedStatusTypes] = useState<string[]>(storedFilters?.status ? storedFilters.status : []);
  const [summaryData, setSummaryData] = useState<GenericSummaryCardItemObject[]>(initialSummaryValuesGRN);
  const [initialSummaryData, setInitialSummaryData] = useState<any>();
  const [textSwitcherItems, setTextSwitcherItems] = useState<TextSwitcherItemObject[]>([]);
  const [sortByColumn, setSortByColumn] = useState<any>();

  useEffect(() => {
    if (sortByColumn && sortByColumn.key && sortByColumn.direction !== "none") {
      const { key: sortKey, direction, type } = sortByColumn;

      const sortedRows = [...rows].sort((a: any, b: any) => {
        const valA = a[sortKey];
        const valB = b[sortKey];

        if (valA == null && valB == null) return 0;
        if (valA == null) return direction === "asc" ? -1 : 1;
        if (valB == null) return direction === "asc" ? 1 : -1;

        if (type === "number") {
          return direction === "asc"
            ? Number(valA) - Number(valB)
            : Number(valB) - Number(valA);
        }

        if (type === "date") {
          const dateA = new Date(valA).getTime();
          const dateB = new Date(valB).getTime();

          if (isNaN(dateA) || isNaN(dateB)) {
            return direction === "asc"
              ? String(valA).localeCompare(String(valB))
              : String(valB).localeCompare(String(valA));
          }

          return direction === "asc" ? dateA - dateB : dateB - dateA;
        }

        return direction === "asc"
          ? String(valA).localeCompare(String(valB))
          : String(valB).localeCompare(String(valA));
      });

      setRows(sortedRows);
    }
  }, [sortByColumn]);


  const openPopup = useCallback((message: string, type: popupType) => {
    setPopupType(type);
    setGenericMessage(message);
    setOpenGenericModal(true);
  }, []);

  const validDateRange = ConfigDictionary.dateRangeConfig ?? 31;
  const validateDateRange = () => {
    if (startDate && endDate && isGapMoreThanNDays(startDate, endDate, validDateRange)) {
      openPopup(`You can't select date range more than ${validDateRange} days!`, "Alert");
      return false;
    }
    if (startDate && endDate && isStartDateIsGreaterThanEndDate(startDate, endDate)) {
      openPopup("To Date should be greater than from date.", "Alert");
      return false;
    }
    updateDatesInLocalStorage(startDate, endDate, feature, pageID);
    return true;
  };

  const handleDatesChange = async () => {
    if (isButtonLoading || !validateDateRange()) return; // Prevent multiple clicks
    setIsButtonLoading(true);
    try {
      storeSessionStorageDates(startDate, endDate);
      const start = getUTCDate(startDate, "start");
      const end = getUTCDate(endDate, "end");
      await getAllGrnData(start, end);
    } finally {
      setIsButtonLoading(false);
    }
  };

  const handleResetDates = async () => {
    if (isButtonLoading) return; // Prevent multiple clicks
    setIsButtonLoading(true);
    try {
      const date = dayjs();
      storeSessionStorageDates(newStartDate, date);
      const start = getUTCDate(newStartDate, "start");
      const end = getUTCDate(date, "end");
      setStartDate(newStartDate);
      setEndDate(date);
      await getAllGrnData(start, end);
    } finally {
      setIsButtonLoading(false);
    }
  };

  const handleSnackbarClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleDownloadAll = async() => {
    if (isButtonLoading) return; // Prevent multiple clicks
    setIsButtonLoading(true);
    try {
      const startTime = window.performance.now();
      await downloadAllReports(allGrnsReportIdRef.current, setSnackbarOpen, startDate, endDate, "type", "primary");

      const endTime = window.performance.now();
      logEvent(analytics, "grns_report_downloaded", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "download_format": "xlsx",
        "download_time": (endTime - startTime),
      });

    } catch(error){
      await sendSlackAlert(
        SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
        "Download All GRNs Failed - ViewAllGrn.tsx",
        `Failed to download all GRN reports for date range ${startDate.format("YYYY-MM-DD")} to ${endDate.format("YYYY-MM-DD")}. Error: ${(error as Error).message}`,
        safeStringify({ error, startDate, endDate, allGrnsReportId: allGrnsReportIdRef.current })
      );
      logEvent(analytics, "grns_report_download_failed", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "error_reason": error
      });
    }
    finally {
      setIsButtonLoading(false);
    }
  };

  const handleSearchValueChange = (newValue: string) => {
    setSearchedValue(newValue);
  };

  const handleStatusFilterChange = (newFilter: string) => {
    setStatusFilter(newFilter);
    updateSessionStorageFilter(FilterKeys.PRIMARY_ViewAllGrn, newFilter);
  };

  const getAllGrnData = async (startDate: string, endDate: string) => {
   setResetSearch(true); 
    setLastRefreshed(dayjs());
    setTimeout(() => setResetSearch(false), 0); 

    setLoader(true);
    try {
      const response = await getGrnList(startDate, endDate);
      let totalGrnData: grnRowsData[] = [];
      let filteredGrnData: grnRowsData[] = [];
      response?.data?.features?.forEach((item: any) => {
        const {
          orderNumber,
          invoiceNumber,
          creationTime,
          grnStatus,
          orderStatus: status,
          netAmount,
          salesDetails,
          totalQuantity,
          totalCaseQuantity,
          totalPieceQuantity,
          totalOtherUnitQuantity
        } = item;

        const totalInitialCaseQuantity = totalCaseQuantity;
        const totalInitialPieceQuantity = totalPieceQuantity
        const totalInitialOtherQuantity = totalOtherUnitQuantity;

        const totalNormalizedQuantity = item.salesDetails?.reduce((acc: number, curr: any) => {
          return acc + (curr.normalizedQuantity || 0);
        }, 0)

        const grnObj = {
          id:invoiceNumber,
          orderNumber,
          invoiceNumber,
          creationTime,
          totalCaseQuantity,
          totalPieceQuantity,
          netAmount,
          status,
          grnStatus,
          totalQuantity,
          showEyeIcon : true,
          redirectViewGRNicon:true,
          totalInitialCaseQuantity ,
          totalInitialPieceQuantity ,
          totalInitialOtherQuantity,
          normalizedQuantity: totalNormalizedQuantity,
        };
        totalGrnData.push(grnObj);
      });
      
      filteredGrnData = totalGrnData.sort((a, b) => {
        const dateA = new Date(a.creationTime);
        const dateB = new Date(b.creationTime);
        return dateB.getTime() - dateA.getTime(); 
      });
      totalGrnData = totalGrnData.sort((a, b) => {
        const dateA = new Date(a.creationTime);
        const dateB = new Date(b.creationTime);
        return dateB.getTime() - dateA.getTime(); 
      });
      
      setRows(filteredGrnData);
      setData(totalGrnData);
    } catch (error) {
      await sendSlackAlert(
        SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
        "Error Fetching GRN Data - ViewAllGrn.tsx",
        `Failed to fetch GRN data for date range ${startDate} to ${endDate}. Error: ${(error as Error).message}`,
        safeStringify({ error, startDate, endDate, statusFilter })
      );
      openPopup("Something went wrong while fetching GRNs", "Error");
    } finally {
      setLoader(false);
    }
  };


  const getInitalTableData = async () => {
    setStartDate(startDate);
    setEndDate(endDate);
    const start = getUTCDate(startDate, "start");
    const end = getUTCDate(endDate, "end");
    await getAllGrnData(start, end);
  };

  const fetchRequiredConfigs = async () => {

    const stages = await getConfigData('order_configuration','grnStages');
    const primaryOrderStages = await getConfigData('order_configuration',"primaryOrderTrackingStages");
    
    const primaryOrderTrackingStages = primaryOrderStages[0]?.configValue ?? []
    const grnStages = stages[0]?.configValue ?? []
    const allGrnsReportId = await getConfigData('order_configuration',"allGrnsReportId");
    const singleGrnReportId = await getConfigData('order_configuration',"singleGrnReportId");


    const grnReportIdConfig = await getConfigData(
      "dms_configuration",
      "grnReportNameId"
    )
    const grnReportId = grnReportIdConfig[0]?.configValue ?? "PrimaryGRNReport";

    setDownloadSingleReportConfig(getDownloadSingleReportConfig(grnReportId));
    allGrnsReportIdRef.current = allGrnsReportId[0]?.configValue ?? grnReportId;
    singleGrnReportIdRef.current = singleGrnReportId[0]?.configValue ?? null;
    primaryOrderTrackingStagesRef.current = primaryOrderTrackingStages;
    setGrnStages([{
      id: "ALLGRN",
      color: "#F0F3FF",
      dmsLabel: "All GRN",
      labelColor: "",
    },...grnStages]);
  };

  
  useEffect(() => {
    logLoadTrace(init,"view_all_grn_page_load_time");
    storeSessionStorageDates(startDate, endDate);
    }, [startDate, endDate]);

  const init = async () => {
    if (isButtonLoading) return; // Prevent if already processing
    setIsButtonLoading(true);
    try {
    setLoader(true);
    await Promise.allSettled([fetchRequiredConfigs(),getInitalTableData(), fetchSummaryData()]);
    }
    finally{
      setLoader(false);
      setIsButtonLoading(false);
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      getInitalTableData();
    }, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, [startDate, endDate]);


  const fetchSummaryData = async () => {
    const start = getUTCDate(startDate, "start");
    const end = getUTCDate(endDate, "end");
    const summary = await generatePrimarySummary(start, end);
    setInitialSummaryData(summary)
  }

  useEffect(() => {
    if(initialSummaryData){

      setSummaryData(
        [
          {
            itemLabel: 'Open GRN',
            itemValue1: initialSummaryData.totalOpenInvoiceCount,
            itemValue2: initialSummaryData.totalOpenInvoiceAmount,
            svgIcon: 'invoiceDisclaimerIcon',
              itemStyles: {
              itemValue1: {
                fontWeight: "bold"
              },
              itemValue2: {
                color: "#D38E48",
                backgroundColor: "#FFF3E0"
              },
              svgIcon: {
                color: "#D38E48"
              }
            },
          
          },
          {
            itemLabel: 'Accepted GRN',
            itemValue1: initialSummaryData.acceptedInvoiceCount,
            itemValue2: initialSummaryData.acceptedInvoiceAmount,
            svgIcon: 'invoicedOrdersSVG',
            itemStyles: {
              itemValue1: {
                fontWeight: "bold"
              },
              itemValue2: {
                color: "#5A865A",
                backgroundColor: "#EAFFEA"
              },
              svgIcon: {
                color: "#5A865A"
              }
            },
          },
            {
            itemLabel: 'Partially Accepted GRN',
            itemValue1: initialSummaryData.partiallyAcceptedInvoiceCount,
            itemValue2: initialSummaryData.partiallyAcceptedInvoiceAmount,
            svgIcon: 'pendingOrdersSVG',
            itemStyles: {
              itemValue1: {
                fontWeight: "bold"
              },
              itemValue2: { 
                color: "#1E88E5",
                backgroundColor: "#E3F2FD"
              },
              svgIcon: { color: '#1E88E5', width: '1em' },
            },
      
          },
          {
            itemLabel: 'Rejected GRN',
            itemValue1: initialSummaryData.rejectedInvoiceCount,
            itemValue2: initialSummaryData.rejectedInvoiceAmount,
            svgIcon: 'rejectedSVG',
            itemStyles: {
              itemValue1: {
                fontWeight: "bold"
              },
              itemValue2: {
                color: "#B54747",
                backgroundColor: "#FFEBEE"
              },
              svgIcon: {
                width: '1em',
                color: "#B54747"
              }
            },
          },
        ]
      )

      setTextSwitcherItems([
      ...(initialSummaryData.totalOpenInvoiceCount > 0
        ? [
            {
              label: "Attention:",
              text: `You have ${initialSummaryData.totalOpenInvoiceCount} Open GRNs in the selected date range.`,
              svgIcon: "disclaimerIcon",
              itemStyles: {
                container: { backgroundColor: "#FFF1FE" },
                label: {

                },
                text: { color: "#7B087B" },
                svg: { 
                  width: "1em",
                  color: "#7B087B"
                },
              },
              actionButton: (
                <button
                  onClick={() => setSelectedStatusTypes(["OPEN"])}
                  style={{
                    padding: "4px 8px",
                    textDecoration: "underline",
                    background: "none",
                    color: "#1B7713",
                    border: "none",
                    fontWeight: 600,
                  }}
                >
                  Show GRNs
                </button>
              ),
            },
          ]
        : [
            {
              label: "Note:",
              text: `You have no open GRNs in the selected date range.`,
              svgIcon: "invoicedOrdersSVG",
              itemStyles: {
                container: { backgroundColor: "#EAFFEA" },
                label: {
                },
                text: { color: "#1B7713" },
                svg: { 
                  width: "1em",
                  color: "#5A865A"
                },
              },
            }
          ]),
       ]);
    }
  }, [initialSummaryData]);

  const filteredData = useMemo(() => {
    localStorage.setItem('viewAllGRNFilter', JSON.stringify({
      "status": selectedStatusTypes,
    }))
    let res = filterData(
      data,
      searchedValue?.toLowerCase(),
      searchWithStatusFilter,
    );
    if (selectedStatusTypes.length > 0) {
      res = res.filter(row => selectedStatusTypes.includes(row.grnStatus));
    }
    return res
  }, [searchedValue, statusFilter, data, selectedStatusTypes]);


  const statusFilterMenuItems = grnStages.filter(b => b.id !== "ALLGRN").map((button) => (
    {
      id: button.id,
      label: button.dmsLabel,
      count: data.filter((invoice) => {
        return invoice.status?.toUpperCase() === button.id;
      }).length,
    }
  ));

  const filters = [
    {
      id: "status",
      label: "Status",
      options: statusFilterMenuItems,
      selectedOptions: selectedStatusTypes,
      setSelectedOptions: setSelectedStatusTypes,
    },
  ];

  useEffect(() => {
    if(!loader) {
      logEvent(analytics, "grn_list_viewed", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "total_grns_displayed": filteredData.length
      });
      console.log("grn-list",filteredData.length)
    }
  },[filteredData,loader,statusFilter]);

  useEffect(() => {
      logEvent(analytics, "primary_module_accessed", {
        "entry_time" : new Date().toISOString(),
      });
      console.log("enter-primary",new Date().toISOString())
  },[])

  useEffect(() => {
    if(searchedValue){
      logEvent(analytics, "search_grn", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "search_query" : searchedValue,
        "result_count": filteredData.length
      });
      console.log("search-grn",filteredData.length,searchedValue)
      }
  },[searchedValue]);

  useEffect(() => {
    setRows(filteredData);
  }, [filteredData]);


  return (
    <div className="primary-order-parent">
      <GenericPopUp
        message={genericMessage}
        type={popupType}
        openGenericModal={openGenericModal}
        setOpenGenericModal={setOpenGenericModal}
      />
      <Snackbar
        open={snackbarOpen}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="info"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Your report will be downloaded shortly.
        </Alert>
      </Snackbar>

      <HeaderV2
        title={"View All GRNs"}
        searchFunction={loader ? () => {} : handleSearchValueChange}
        onRefresh={init}
        lastRefreshed={lastRefreshed}
        resetSearch={resetSearch}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        startDate={startDate}
        endDate={endDate}
        setDateRangeLabel={setDateRangeLabel}

      />
  
      <GenericSummaryCard cardTitle='Summary' itemObjects={summaryData}/>
      <div className="primary-order-filter-bar">
        <TextSwitcher textSwitcherItems={textSwitcherItems} />
        <div className="primary-order-filter-container">
          <MultiCategoryFilterV2
            isOpen={filterOpen}
            setIsOpen={setFilterOpen}
            activeFilter={selectedFilterType}
            setActiveFilter={setSelectedFilterType}
            filters={filters}
            label="Type & Status"
            searchValue={filterSearchValue}
            onSearchChange={setFilterSearchValue}
            showSearch={true}
          />
        </div>
      </div>

      {loader ? (
        <Loader />
      ) : (
        <CustomDataGrid
          rows={rows}
          columnsMetaData={ViewAllGrnConfigV2}
          downloadSingleReportConfig={downloadSingleReportConfig}
          orderStatusConfig={primaryOrderTrackingStagesRef.current}
          grnStatusConfig={grnStages}
          redirectUrl="/purchase/grn/viewGrnDetails/"
          openButtonNavigateUrl="purchase/grn"
          tableWidth={0.73}
          enableRowClickRedirect={true}
          isPrimaryModuleReport={true}
          setSortByColumn={setSortByColumn}
        />
      )}
    </div>
  );
};

export default ViewAllGrn;
